import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {HTTP_INTERCEPTORS, HttpBackend, HttpClientModule} from "@angular/common/http";
import {MarkantElementsModule} from "@markant/elements-angular";
import {AppRoutingModule} from "./app-routing.module";
import {AuthClientConfig, AuthHttpInterceptor, AuthModule} from "@auth0/auth0-angular";
import {AppComponent} from "./app.component";
import {ReportComponent} from "./reports/report.component";
import {PageComponent} from './page/page.component';
import {environment} from "../environments/environment";

function configInitializer(handler: HttpBackend, config: AuthClientConfig) {
  return () => config.set(environment.authConfig);
}

@NgModule({
  declarations: [
    ReportComponent,
    AppComponent,
    PageComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    MarkantElementsModule.forRoot(),
    AuthModule.forRoot(environment.authConfig)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configInitializer,
      deps: [HttpBackend, AuthClientConfig],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
